var React = require('react');

function SVGIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M20.8555 18C21.9555 18 22.8555 17.1 22.8555 16V6C22.8555 4.9 21.9555 4 20.8555 4H4.85547C3.75547 4 2.85547 4.9 2.85547 6V16C2.85547 17.1 3.75547 18 4.85547 18H0.855469V20H24.8555V18H20.8555ZM4.85547 6H20.8555V16H4.85547V6Z"}));
}

SVGIcon.defaultProps = {"viewBox":"0 0 25 24","fill":"none"};

module.exports = SVGIcon;

SVGIcon.default = SVGIcon;
